import { joinClassNames } from "../lib/utils/join_classnames";
import { nameToInitials } from "../lib/utils/initials";

export const Avatar = ({
  name,
  photo,
  className = "",
}: {
  name: string;
  photo: string | null;
  className: string;
}) => {
  if (photo) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={photo}
        className={joinClassNames("rounded-full ring-2 ring-white", className)}
        alt="Avatar of {name}"
        title={name}
      ></img>
    );
  } else {
    return (
      <span
        className={joinClassNames(
          "inline-flex items-center justify-center rounded-full bg-gray-500 ring-2 ring-white",
          className
        )}
        title={name}
      >
        <span className="font-medium leading-none text-white">
          {nameToInitials(name)}
        </span>
      </span>
    );
  }
};

export const AvatarGroup = ({
  people,
  className = "",
}: {
  people: { name: string; photo: string | null }[];
  className: string;
}) => {
  return (
    <div className="flex -space-x-1 overflow-hidden">
      {people.map((person) => (
        <Avatar
          key={person.name}
          className={className}
          name={person.name}
          photo={person.photo}
        />
      ))}
    </div>
  );
};
